import { ICON_MAPPING } from './icons'
// import * as battery0 from '@/../images/icons/geoenergy/battery0.svg'
// import * as battery20 from '@/../images/icons/geoenergy/battery20.svg'
// import * as battery40 from '@/../images/icons/geoenergy/battery40.svg'
// import * as battery60 from '@/../images/icons/geoenergy/battery60.svg'
// import * as battery80 from '@/../images/icons/geoenergy/battery80.svg'
// import * as battery100 from '@/../images/icons/geoenergy/battery100.svg'
import * as chp from '@/../images/icons/geoenergy/chp.svg'
// import * as container from '@/../images/icons/geoenergy/container.svg'
// import * as containerAlarm from '@/../images/icons/geoenergy/container_alarm.svg'
// import * as containerOk from '@/../images/icons/geoenergy/container_ok.svg'
// import * as containerWarning from '@/../images/icons/geoenergy/container_warning.svg'
import * as factory from '@/../images/icons/geoenergy/factory.svg'
import * as dashboardCenterIcon from '@/../images/icons/geoenergy/dashboard_center_icon.svg'
// import * as wallboxPlugged from '@/../images/icons/geoenergy/wallbox_plugged.svg'
// import * as wallboxUnplugged from '@/../images/icons/geoenergy/wallbox_unplugged.svg'
// import * as wallboxWarning from '@/../images/icons/geoenergy/wallbox_warning.svg'
import * as fuelcell from '@/../images/icons/geoenergy/fuelcell.svg'
// import * as generic from '@/../images/icons/geoenergy/generic.svg'
import * as grid from '@/../images/icons/geoenergy/grid.svg'
// import * as heatingelement from '@/../images/icons/geoenergy/heatingelement.svg'
import * as heatpump from '@/../images/icons/geoenergy/heatpump.svg'
import * as pv from '@/../images/icons/geoenergy/pv.svg'
// import * as rest from '@/../images/icons/geoenergy/rest.svg'
// import * as trafo from '@/../images/icons/geoenergy/trafo.svg'
import * as user from '@/../images/icons/geoenergy/user.svg'

const map = {
  // battery: battery0,
  // battery0,
  // battery20,
  // battery40,
  // battery60,
  // battery80,
  // battery100,
  chp,
  // container,
  // containerAlarm,
  // containerOk,
  // containerWarning,
  dashboardCenterIcon,
  factory,
  fuelcell,
  // generic,
  grid,
  // heatingelement,
  heatpump,
  pv,
  // rest,
  // trafo,
  user
  // wallbox: wallboxUnplugged,
  // wallboxPlugged,
  // wallboxUnplugged,
  // wallboxWarning
}

export function overwriteIcons() {
  Object.assign(ICON_MAPPING, map)
}
